import axios from "axios";
import baseUrl from "./baseUrl";
import {
	PermissionaryConfiguration,
	UpdatePermissionaryConfigurationDto,
} from "../models/PermissionaryConfiguration";
import { Permissionary } from "../models/Permissionary";

export default class PermissionaryConfigurationApi {
	static resourceUrl = baseUrl + "/permissionary-configuration";

	static async fetchConfiguration(
		permissionaryId: string,
		accessToken: string,
	): Promise<PermissionaryConfiguration> {
		// Send a POST request
		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/" + permissionaryId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + accessToken,
			},
		});

		return response.data;
	}

	static async updateConfiguration(
		permissionaryId: string,
		dto: UpdatePermissionaryConfigurationDto,
		accessToken: string,
	): Promise<PermissionaryConfigurationApi> {
		// Send a POST request
		const response = await axios({
			method: "PUT",
			url: this.resourceUrl + "/" + permissionaryId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + accessToken,
			},
			data: dto,
		});

		return response.data;
	}
}
